import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomDataGrid from "../../UI Helpers/DataGrid/CustomDataGrid";
import Settings from "../../CommonAPICalls/Settings";
import CommonCalls from "../../CommonAPICalls/CommonCalls";
import { gridLinkValueFormatter, showAlertMessage, checkIfArrayIsEmpty } from "../../MasterComponents/CommonFunctionalities";
import { getArrayItemFromLocalStorage } from "../../UI Helpers/TabRecorder/TabRecorderFunctions";

const SystemUsersListings = () => {
  const [userData, setUserData] = useState([]);

  const [loading, setLoading] = useState(true);

  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNumber, setPageNumber] = useState(getArrayItemFromLocalStorage(0));
  const [pageSize, setPageSize] = useState(10);
  const [examDetails, setExamDetails] = useState([]);
  const [searchedData , setSearchedData] = useState("")

  const apiCalls = new CommonCalls();

  const navigate = useNavigate();

  useEffect(() => {
    getAllUsers();
  }, [pageNumber, pageSize,searchedData]);

  const getAllUsers = async () => {
    setLoading(true);
    try {
      const apiResponse = await apiCalls.getSystemUsers(pageNumber, pageSize,searchedData);
      if (apiResponse) {
        setUserData(apiResponse?.data);
        setTotalRecords(apiResponse?.total_records);
        setLoading(false);
      }
    } catch (err) {
      setUserData([]);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const onEmailClicked = (row, colKey) => {
    if (colKey === 'email') {
      navigate(`/portal/system-users?userid=${row?.user_id}`);
    }
  };

  const onDeleteSystemUsers = async (rowItems) => {
    if (checkIfArrayIsEmpty(rowItems)) {
      showAlertMessage('Please select any rows to delete!', 'fail');
      return;
    };

    setLoading(true);

    for (const item of rowItems) {
      try {
        const apiResponse = await apiCalls.removeSystemUser(item?.user_id);
        if (apiResponse) {
          showAlertMessage(apiResponse?.message, 'success');
        }
      } catch (error) {
        showAlertMessage(error, 'fail');
      }
    };

    getAllUsers();
  };

  const handleSearch = async (searchData) => {
    if (!searchData || searchData === "") {
      showAlertMessage("Please provide a search query!", 'fail');
      return
    };

    setSearchedData(searchData)

    setLoading(true);
    try {
      const response = await apiCalls.getSystemUsers(1, 10, searchData);
      if (response) {
        setUserData(response?.data);
        setTotalRecords(response?.total_records);
        setLoading(false);
      }
    } catch (error) {
      showAlertMessage("No users found with your provided query!", 'fail');
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const onRefreshGridClick = () => { getAllUsers() };

  const gridColumnHeaders = [
    { field: 'email', cellRenderer: gridLinkValueFormatter, customRendererLink: true, columnName: 'Email' },
    { field: 'full_name', columnName: 'Full Name' },
    { field: 'phone_number', columnName: 'Phone Number' },
    { field: 'student_category', columnName: 'Student Category', inputType: "dropdown", options: Settings.enumTypes },
  ];

  return (
    <div className='listings_view_wrapper'>
      <h1 className="h1_main">All System Users</h1>

      <CustomDataGrid
        columns={gridColumnHeaders}
        data={userData}
        pageSize={pageSize}
        onSearch={handleSearch}
        onRefresh={onRefreshGridClick}
        onSelectedRowsDelete={onDeleteSystemUsers}
        loadingState={loading}
        hideAddBtn={true}
        pagination={true}
        onCellClicked={onEmailClicked}
        totalRecords={totalRecords}
        currentPage={pageNumber}
        onPageChange={setPageNumber}
        onPageSizeChange={setPageSize}
        searchField={true}
        tabID={0}
        setSearchFeildData={setSearchedData}

         hideExcelBtn={false}
          excelFileBtnType={"StudentsData"}
          excelFn={apiCalls.getSystemUsers}
          excelArgument={[1,totalRecords]}
      />
    </div>
  );
};

export default SystemUsersListings; 